import Icon, { Props } from '../Icon'

export type RenderIconOptions = Omit<Props, 'glyph'> & { key?: string }

export const renderIcon = (icon: string, options: RenderIconOptions = {}) => {
  if (icon) {
    return <Icon key={icon} glyph={icon} {...options} />
  }

  return null
}
